import React from 'react';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/vertical.css';

const content = [
  {
    title: (
      <span style={{ color: "#FFB5BA", textShadow: "2px 2px 4px #FED8A6" }}>
        {"Dr. Michelle Malik, ND, CPT, HBSc"}
      </span>
    ),
    description: (
      <span style={{ color: "#BADDD6" }}>{"Naturopathic Doctor"}</span>
    ),
    image: "./img/bg-4.png"
  },
  {
    title: (
      <span style={{ color: "#FFB5BA", textShadow: "2px 2px 4px #FED8A6" }}>
        {"Holistic Sports Medicine"}
      </span>
    ),
    description: (
      <span style={{ color: "#BADDD6" }}>{"Optimizing athletes inside & out"}</span>
    ),
    image: "./img/bg-2.jpg"
  },
];

export default () => (
  <Slider className="slider-wrapper" autoplay={6000}>
    {content.map((item, index) => (
      <div
        key={index}
        className="slider-content"
        style={{ background: `url('${item.image}') no-repeat center center` }}
      >
        <div className="inner">
          <h1>{item.title}</h1>
          <p>{item.description}</p>
          <a
  href="https://drmichellendstudeogyms.janeapp.com/"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: "inline-block",
    margin: "2rem 0 1rem",
    padding: "0.75rem 1.5rem",
    border: "2px solid #FED8A6",
    color: "#FED8A6",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "bold",
    backgroundColor: "transparent",
    transition: "all 0.3s ease",
  }}
  onMouseOver={(e) => {
    e.target.style.backgroundColor = "#92ADA4";
    e.target.style.color = "#fff";
  }}
  onMouseOut={(e) => {
    e.target.style.backgroundColor = "transparent";
    e.target.style.color = "#FED8A6";
  }}
>
  Book Now
</a>
        </div>
      </div>
    ))}
  </Slider>
);
